import type { GraphState } from 'components/Graph/GraphState';
import { selectCollapsedNodeGroupIds } from 'components/Graph/model/selectors/selectCollapsedNodeGroupIds';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectSomeCollapsedNodeGroupSelected: (s: GraphState) => boolean =
  createScopedSelector(() =>
    createSelector(
      (s) => s.graph.selectedNodeIds,
      selectCollapsedNodeGroupIds,
      (selectedNodeIds, collapsedNodeGroupIds) =>
        collapsedNodeGroupIds.some((id) => selectedNodeIds.has(id)),
    ),
  );
